import { Component } from '@angular/core';
import { IonicPage, NavController, LoadingController, AlertController, Loading, Alert } from 'ionic-angular';
import { AwsProvider } from '../../providers/aws/aws';
import { ComplianceDomainPage } from '../compliance-domain/compliance-domain';

export interface Domain {
  text: string;
}

@IonicPage()
@Component({
  selector: 'page-compliance',
  templateUrl: 'compliance.html',
})
export class CompliancePage {

  domains: Array<Domain>;
  filteredDomains: Array<Domain>;
  filter: string;
  hidden: object;

  constructor(public navCtrl: NavController, public aws: AwsProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    this.domains = [];
    this.filteredDomains = [];
    this.filter = '';
    this.hidden = JSON.parse(
      window.localStorage.getItem('sherloq_admin_hidden_domains') || '{}'
    );
  }

  async ionViewDidEnter(): Promise<void> {
    const loading: Loading = this.loadingCtrl.create({});
    loading.present();
    const result: object = await this.aws.invokeLambda('SherloqAdminFEGetComplianceDomains:v1');
    if (!result['success']) {
      const alert: Alert = this.alertCtrl.create({
        message: result['response'],
        buttons: ['Ok'],
        enableBackdropDismiss: true
      });
      alert.present();
    } else {
      this.domains = result['response']['domains'];
      this.filterDomains();
    }
    loading.dismiss();
  }

  filterDomains(): void {
    this.filteredDomains = [];
    const filter: string = this.filter.trim().toLowerCase();
    for (let domain of this.domains) {
      if (!this.hidden['#SHOWHIDDEN'] && this.hidden[domain.text]) continue;
      if (filter.length === 0) {
        this.filteredDomains.push(domain);
      } else if (domain.text.indexOf(filter) > -1) {
        this.filteredDomains.push(domain);
      }
    }
  }

  goToDomain(domain: Domain): void {
    this.navCtrl.push(ComplianceDomainPage, { domain, domains: this.domains });
  }

  toggleDomain(domain: Domain): void {
    if (this.hidden[domain.text]) this.hidden[domain.text] = false;
    else this.hidden[domain.text] = true;
    window.localStorage.setItem(
      'sherloq_admin_hidden_domains',
      JSON.stringify(this.hidden)
    );
    this.filterDomains();
  }

}



// WEBPACK FOOTER //
// ./src/pages/compliance/compliance.ts